import React from 'react';

const CommonLoadingSpinner = () => {
  const spinnerStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '6.5px',
    height: '6.5px',
    zIndex: 1000
  };

  const divStyle = (delay, rotation) => ({
    position: 'absolute',
    width: '50%',
    height: '150%',
    background: 'rgb(60, 116, 221)',
    transform: `rotate(${rotation}deg) translate(0, 150%)`,
    animation: `spinner-animation 1s ${delay}s infinite ease`
  });

  return (
    <>
      <style>
        {`
          @keyframes spinner-animation {
            0%, 10%, 20%, 30%, 40%, 60%, 70%, 80%, 90%, 100% {
              transform: rotate(var(--rotation)) translate(0, 150%);
            }
            50% {
              transform: rotate(var(--rotation)) translate(0, 225%);
            }
          }
        `}
      </style>
      <div style={spinnerStyle}>
        <div style={{...divStyle(0.1, 36), '--rotation': '36deg'}}></div>
        <div style={{...divStyle(0.2, 72), '--rotation': '72deg'}}></div>
        <div style={{...divStyle(0.3, 108), '--rotation': '108deg'}}></div>
        <div style={{...divStyle(0.4, 144), '--rotation': '144deg'}}></div>
        <div style={{...divStyle(0.5, 180), '--rotation': '180deg'}}></div>
        <div style={{...divStyle(0.6, 216), '--rotation': '216deg'}}></div>
        <div style={{...divStyle(0.7, 252), '--rotation': '252deg'}}></div>
        <div style={{...divStyle(0.8, 288), '--rotation': '288deg'}}></div>
        <div style={{...divStyle(0.9, 324), '--rotation': '324deg'}}></div>
        <div style={{...divStyle(1.0, 360), '--rotation': '360deg'}}></div>
      </div>
    </>
  );
};

export default CommonLoadingSpinner;